import { z } from "zod";
import { frazioneMerceologicaSchema, paginationSchema } from "./common.js";
export const statoTurnoSchema = z.enum([
    "PIANIFICATO",
    "IN_CORSO",
    "CHIUSO",
    "ANNULLATO",
]);
export const turnoSchema = z.object({
    id: z.string().uuid(),
    operatore_id: z.string().uuid(),
    zona_id: z.string().uuid(),
    frazione_merceologica: frazioneMerceologicaSchema,
    data_turno: z.string(),
    ora_inizio: z.string().datetime().nullable(),
    ora_fine: z.string().datetime().nullable(),
    mezzo_targa: z.string().max(16).nullable(),
    stato: statoTurnoSchema,
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    operatore: z
        .object({ nome: z.string(), cognome: z.string() })
        .optional(),
    zona: z.object({ nome: z.string(), codice: z.string() }).optional(),
});
export const createTurnoSchema = z.object({
    operatore_id: z.string().uuid(),
    zona_id: z.string().uuid(),
    frazione_merceologica: frazioneMerceologicaSchema,
    data_turno: z.string(),
    mezzo_targa: z.string().max(16).optional(),
});
export const turnoFiltersSchema = paginationSchema.extend({
    stato: statoTurnoSchema.optional(),
    operatore_id: z.string().uuid().optional(),
    zona_id: z.string().uuid().optional(),
    data_da: z.string().optional(),
    data_a: z.string().optional(),
    frazione: frazioneMerceologicaSchema.optional(),
});
export const updateTurnoSchema = z.object({
    zona_id: z.string().uuid().optional(),
    frazione_merceologica: frazioneMerceologicaSchema.optional(),
    data_turno: z.string().optional(),
    mezzo_targa: z.string().max(16).nullable().optional(),
    stato: statoTurnoSchema.optional(),
});
export const zonaSchema = z.object({
    id: z.string().uuid(),
    nome: z.string().max(120),
    codice: z.string().max(32),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const createZonaSchema = z.object({
    nome: z.string().min(1).max(120),
    codice: z.string().min(1).max(32),
});
export const updateZonaSchema = createZonaSchema.partial();
export const mezzoSchema = z.object({
    id: z.string().uuid(),
    targa: z.string().max(16),
    descrizione: z.string().max(120).nullable(),
    attivo: z.boolean(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const createMezzoSchema = z.object({
    targa: z.string().min(1).max(16),
    descrizione: z.string().max(120).optional(),
});
export const updateMezzoSchema = createMezzoSchema.partial().extend({
    attivo: z.boolean().optional(),
});
//# sourceMappingURL=turni.js.map